import * as React from "react";
import {REQUEST} from "../../util/Request";
import {URLs} from "../../util/Constants";
import {UploadFileWrapper} from "../../request/UploadFileWrapper/UploadFileWrapper";
import {enviarDocumentos, limpiarEstadoEnviarDocumentos} from "../../redux/modules/cargaDocumental/actions";
import {ValidationUtils} from "../../util/ValidationUtils";
import {DocumentosUtils} from "../../util/DocumentosUtils";
import {EnviarDocumentosRequest} from "../../request/EnviarDocumentosRequest/EnviarDocumentosRequest";
import {Route, Switch} from "react-router-dom";
import CargaDocumental from "../CargaDocumental/CargaDocumental";
import EstadoDocumentos from "../EstadoDocumentos/EstadoDocumentos";
import {connect} from "react-redux";
import * as R from "ramda";
import withRecaptcha from "../../hoc/WithRecaptcha";

export class DocumentosSinConectar extends React.Component<any, any> {

  tempFormData: any;

  docs = [];
  docsAfiliado = [];
  docsEmpleadores = [];
  docsBeneficiarios = [];
  docsApoderados = [];
  docsReclamantes= [];
  docsCuradores = [];
  formatos = [];
  docsBeneficiariosPropietarios;
  docsCuradoresPropietarios;
  docsReclamantesPropietarios;
  docsApoderadosPropietarios;
  docsEmpleadoresPropietarios;
  docsPendientes = [];
  docsPendientesAfiliado = [];
  docsPendientesEmpleadores = [];
  docsPendientesApoderados = [];
  docsPendientesBeneficiarios = [];
  docsPendientesReclamantes= [];
  docsPendientesCuradores = [];
  docsPendientesBeneficiariosValidate = [];
  docsPendientesCuradoresValidate = [];
  docsPendientesReclamantesValidate = [];
  docsPendientesApoderadosValidate = [];
  docsPendientesEmpleadoresValidate = [];
  docsPendientesFormatos = [];
  solicitante;
  showDocPendientesAlert = true;

  constructor(props: any) {
    super(props);
    this.state = {
      showLoad: false,
      showSuccess: false,
      showError: false,
      showInfo: false,
      render: true,
      error: "",
      info: ""
    };
  }

  componentWillMount(): void {
    if (!this.props.solicitud) {
      this.setState({render: false});
      this.props.history.push("/");
    } else {
      this.prepareDocuments();
    }
  }

  componentWillUnmount(): void {
    this.props.dispatch(limpiarEstadoEnviarDocumentos());
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.estadoEnviarDocumentos === REQUEST.SUCCESS) {
      this.setState({showSuccess: true, showLoad: false});
    } else if (nextProps.estadoEnviarDocumentos === REQUEST.ERROR) {
      if (nextProps.errorEnviarDocumentos.includes("no tiene documentos pendientes de cargue") ) {
        this.setState({showInfo: true, showLoad: false, info: "Tus documentos ya fueron cargados exitosamente. " +
            "Te notificaremos a través de tus medios de contacto registrados en Protección en cuanto haya una novedad."});
      } else {
        if (nextProps.errorEnviarDocumentos.includes("Error técnico de timeout") ) {
          this.setState({showInfo: true, showLoad: false, info: "El tiempo para el cargue de los documentos fue mayor " +
              "a lo esperado. Por favor valide nuevamente su solicitud en unos minutos."});
        } else {
          this.setState({showError: true, showLoad: false, error: 
              nextProps.errorEnviarDocumentos.replace("Hubo un error al recibir el comando: ", "")});
        }
      }
    } else if (nextProps.estadoEnviarDocumentos === REQUEST.PENDING) {
      this.setState({showLoad: true});
    }
  }

  render() {
    return (
      <Switch>
        <Route path={URLs.CARGA_DOCUMENTAL} component={(props) =>
          <CargaDocumental {...props}
                           showSuccess={this.state.showSuccess}
                           showLoad={this.state.showLoad}
                           showInfo={this.state.showInfo}
                           showError={this.state.showError}
                           error={this.state.error}
                           info={this.state.info}
                           solicitante={this.solicitante}
                           docsAfiliado={this.docsAfiliado}
                           docsEmpleadores={this.docsEmpleadores}
                           docsApoderados={this.docsApoderados}
                           docsBeneficiarios={this.docsBeneficiarios}
                           docsReclamantes={this.docsReclamantes}
                           docsCuradores={this.docsCuradores}
                           docsBeneficiariosPropietarios={this.docsBeneficiariosPropietarios}
                           docsReclamantesPropiertarios={this.docsReclamantesPropietarios}
                           docsCuradoresPropietarios={this.docsCuradoresPropietarios}
                           docsApoderadosPropietarios={this.docsApoderadosPropietarios}
                           docsEmpleadoresPropietarios={this.docsEmpleadoresPropietarios}
                           formatos={this.formatos}
                           handleSubmit={this.validateCaptcha}
                           closeDialogs={this.closeDialogs}
                           validateForm={this.validateForm}
                           isLoading={this.isLoading}
                           solicitud={this.props.solicitud}
                           isSubmitButtonDisabled={this.isSubmitButtonDisabled}
                           goBack={this.goBack}
                           downloadTemplate={this.downloadTemplate}
          />}/>
        <Route path={URLs.ESTADO_DOCUMENTOS} component={(props) =>
          <EstadoDocumentos {...props}
                            showSuccess={this.state.showSuccess}
                            showInfo={this.state.showInfo}
                            docsAfiliado={this.docsAfiliado}
                            docsEmpleadores={this.docsEmpleadores}
                            docsApoderados={this.docsApoderados}
                            docsBeneficiarios={this.docsBeneficiarios}
                            docsReclamantes={this.docsReclamantes}
                            docsCuradores={this.docsCuradores}
                            docsBeneficiariosPropietarios={this.docsBeneficiariosPropietarios}
                            docsReclamantesPropietarios={this.docsReclamantesPropietarios}
                            docsCuradoresPropietarios={this.docsCuradoresPropietarios}
                            docsApoderadosPropietarios={this.docsApoderadosPropietarios}
                            docsEmpleadoresPropietarios={this.docsEmpleadoresPropietarios}
                            pendingDocs={this.docsPendientes}
                            docsPendientesAfiliado={this.docsPendientesAfiliado}
                            docsPendientesEmpleadores={this.docsPendientesEmpleadores}
                            docsPendientesApoderados={this.docsPendientesApoderados}
                            docsPendientesBeneficiarios={this.docsPendientesBeneficiarios}
                            docsPendientesReclamantes={this.docsPendientesReclamantes}
                            docsPendientesCuradores={this.docsPendientesCuradores}
                            formatos={this.formatos}
                            docsPendientesFormatos={this.docsPendientesFormatos}
                            solicitante={this.solicitante}
                            showAlert={this.showDocPendientesAlert}
                            handleSubmit={this.validateCaptcha}
                            closeDialogs={this.closeDialogs}
                            validateForm={this.validateForm}
                            isLoading={this.isLoading}
                            solicitud={this.props.solicitud}
                            isSubmitButtonDisabled={this.isSubmitButtonDisabled}
                            goBack={this.goBack}
                            downloadTemplate={this.downloadTemplate}
          />}/>
      </Switch>

    );
  }

  prepareDocuments = () => {
    this.docs = this.props.solicitud.documentos;
    this.docsAfiliado = DocumentosUtils.filtrarDocsAfiliado(this.docs);
    this.docsEmpleadores = DocumentosUtils.filtrarDocsEmpleador(this.docs);
    this.docsApoderados = DocumentosUtils.filtrarDocsApoderado(this.docs);
    this.docsBeneficiarios = DocumentosUtils.filtrarDocsBeneficiario(this.docs);
    this.docsReclamantes = DocumentosUtils.filtrarDocsReclamante(this.docs);
    this.docsCuradores = DocumentosUtils.filtrarDocsCurador(this.docs);
    this.formatos = DocumentosUtils.filtrarFormatos(this.docs);
    this.docsPendientesAfiliado = DocumentosUtils.filtrarDocsPendientesAfiliado(this.docsAfiliado);
    this.docsPendientesEmpleadores = DocumentosUtils.docsPendientes(this.docsEmpleadores);
    this.docsPendientesApoderados = DocumentosUtils.docsPendientes(this.docsApoderados);
    this.docsPendientesBeneficiarios = DocumentosUtils.docsPendientes(this.docsBeneficiarios);
    this.docsPendientesReclamantes = DocumentosUtils.docsPendientes(this.docsReclamantes);
    this.docsPendientesCuradores = DocumentosUtils.docsPendientes(this.docsCuradores);
    this.docsPendientesFormatos = DocumentosUtils.docsPendientesFormatos(this.formatos);
    this.docsPendientesBeneficiariosValidate = DocumentosUtils
      .filtrarDocsPendientesBeneficiarios(this.docsBeneficiarios);
    this.docsPendientesApoderadosValidate = DocumentosUtils
      .filtrarDocsPendientesApoderados(this.docsApoderados);
    this.docsPendientesCuradoresValidate = DocumentosUtils
      .filtrarDocsPendientesCuradores(this.docsCuradores);
    this.docsPendientesReclamantesValidate = DocumentosUtils
      .filtrarDocsPendientesReclamantes(this.docsReclamantes);
    this.docsPendientesEmpleadoresValidate = DocumentosUtils
      .filtrarDocsPendientesEmpleadores(this.docsEmpleadores);
    this.docsBeneficiariosPropietarios = DocumentosUtils.agruparDocsPorPropietario(this.docsBeneficiarios);
    this.docsApoderadosPropietarios = DocumentosUtils.agruparDocsPorPropietario(this.docsApoderados);
    this.docsCuradoresPropietarios = DocumentosUtils.agruparDocsPorPropietario(this.docsCuradores);
    this.docsReclamantesPropietarios = DocumentosUtils.agruparDocsPorPropietario(this.docsReclamantes);
    this.docsEmpleadoresPropietarios = DocumentosUtils.agruparDocsPorPropietario(this.docsEmpleadores);
    this.solicitante = this.props.solicitud.solicitante;
  }

  validateForm = (values) => {
    const fields: Array<string> = [];
    fields.push(...this.docsPendientesAfiliado);
    fields.push(...this.docsPendientesEmpleadoresValidate);
    fields.push(...this.docsPendientesApoderadosValidate);
    fields.push(...this.docsPendientesCuradoresValidate);
    fields.push(...this.docsPendientesReclamantesValidate);
    fields.push(...this.docsPendientesBeneficiariosValidate);
    fields.push(...this.docsPendientesFormatos);

    return ValidationUtils.validateRequiredFields(fields, values);
  }

  validateCaptcha = (formData) => {
    this.tempFormData = formData;
    this.props.setOnRecaptchaSuccessFunction(this.onCaptchaSuccess);
    this.props.recaptchaValidate();
  }

  onCaptchaSuccess = recaptchaToken => {
    this.hideDocPendientesAlert();
    const files: Array<UploadFileWrapper> = [];
    Object.keys(this.tempFormData).forEach(docIdShort => {
      const docIdFull = DocumentosUtils.obtenerIdCompletoDocumento(this.docs, docIdShort);
      files.push(new UploadFileWrapper(docIdFull, this.tempFormData[docIdShort]));
    });
    const requestBody = new EnviarDocumentosRequest(
      this.props.solicitud.tipo.nombre,
      this.props.solicitud.id,
      recaptchaToken,
      files
    );
    this.props.dispatch(enviarDocumentos(requestBody));
  }

  isLoading = () => {
    return this.props.estadoEnviarDocumentos === REQUEST.PENDING;
  }

  closeDialogs = () => {
    this.setState({showError: false, showSuccess: false, showLoad: false, showErrorDoc: false});
  }

  isSubmitButtonDisabled = (errors) => {
    return Object.getOwnPropertyNames(errors).length > 0 || this.isLoading();
  }

  hideDocPendientesAlert = () => {
    this.showDocPendientesAlert = false;
  }

  goBack = () => {
    const {history} = this.props;
    history.push(URLs.HOME);
  }

  downloadTemplate = (doc) => {
    window.open(doc.urlFormato);
  }
}

const Documentos: any = connect(
  (store: any) => {
    return {
      solicitud:
        R.pathOr(undefined, ["recDocInternet", "solicitudes", "solicitud"], store),
      estadoEnviarDocumentos:
        R.pathOr(REQUEST.NONE, ["recDocInternet", "carga", "estadoEnviarDocumentos"], store),
      errorEnviarDocumentos:
        R.pathOr(undefined, ["recDocInternet", "carga", "errorEnviarDocumentos"], store),
    };
  },
)(DocumentosSinConectar);
export default withRecaptcha(Documentos);
